import { render, staticRenderFns } from "./DocumentPOSMoney.vue?vue&type=template&id=f986aa84"
import script from "./DocumentPOSMoney.vue?vue&type=script&lang=js"
export * from "./DocumentPOSMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports